// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"HorizontalTwoLineLabelWithData_tooltip__3-kaC","colorBox":"HorizontalTwoLineLabelWithData_colorBox__T-wWM"};